// extracted by mini-css-extract-plugin
export default {"skeleton":"SkeletonProductCard_skeleton__3ws+N","skeleton-loading":"SkeletonProductCard_skeleton-loading__fj-oL"};